import React from 'react';
import { StyleSheet, View } from 'react-native';

import Button from 'components/Button';
import { usePlayer } from 'components/Player/context';

const SectionVideo: React.FC<CmsHomeSectionVideo> = (props) => {
  const { play, isPlaying, media } = usePlayer();
  return (
    <View style={styles.container}>
      {(!isPlaying || media?.id !== props.mediaId) && (
        <View style={styles.buttonContainer}>
          <Button onPress={play}>{props.title}</Button>
        </View>
      )}
    </View>
  );
};

export default React.memo(SectionVideo);

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  buttonContainer: {
    position: 'absolute',
    top: '50%',
    left: 15,
  },
});
